import { createContext } from 'react';

const planetsContext = createContext();

export default planetsContext;
